/*
 *
 *  actions
 *
 */

import {
  LOAD_RECORDS_VALID_CACHE,
  LOAD_RECORDS_META_DATA,
  LOAD_RECORDS_META_DATA_SUCCESS,
  LOAD_RECORDS_META_DATA_ERROR,

  LOAD_EVENT_CANCELLED_LIST,
  LOAD_EVENT_CANCELLED_LIST_SUCCESS,
  LOAD_EVENT_CANCELLED_LIST_ERROR,

  UPDATE_EVENT_CANCEL,
  UPDATE_EVENT_CANCEL_SUCCESS,
  UPDATE_EVENT_CANCEL_ERROR
} from "./constants"

export function loadRecordsCacheHit() {
  return {
    type: LOAD_RECORDS_VALID_CACHE,
  }
}

export function loadRecordsMetaData() {
  return {
    type: LOAD_RECORDS_META_DATA,
  }
}

/**
 *
 * @param {object} recordsMetaData
 * @returns
 */
export function loadRecordsMetaDataSuccess(recordsMetaData) {
  return {
    type: LOAD_RECORDS_META_DATA_SUCCESS,
    recordsMetaData,
  }
}

/**
 *
 * @param {string} error
 * @returns
 */
export function loadRecordsMetaDataError(error) {
  return {
    type: LOAD_RECORDS_META_DATA_ERROR,
    error,
  }
}

//permission list
export function loadEventCancelledList(searchvalue) {
  return {
    type: LOAD_EVENT_CANCELLED_LIST,
    searchvalue,
  }
}
export function loadEventCancelledListSuccess(event_cancelled_details) {
  return {
    type: LOAD_EVENT_CANCELLED_LIST_SUCCESS,
    event_cancelled_details,
  }
}
export function loadEventCancelledListError(error) {
  return {
    type: LOAD_EVENT_CANCELLED_LIST_ERROR,
    error,
  }
}


//update event cancel

export function updateEventCancel(eventCancelDetails) {
  return {
    type: UPDATE_EVENT_CANCEL,
    eventCancelDetails,
  }
}
export function updateEventCancelSuccess(eventCancelDetails) {
  return {
    type: UPDATE_EVENT_CANCEL_SUCCESS,
    eventCancelDetails,
  }
}
export function updateEventCancelError(error) {
  return {
    TYPE: UPDATE_EVENT_CANCEL_ERROR,
    error,
  }
}

const actions = {
  loadRecordsCacheHit,
  loadRecordsMetaData,
  loadRecordsMetaDataSuccess,
  loadRecordsMetaDataError,

  loadEventCancelledList,
  loadEventCancelledListSuccess,
  loadEventCancelledListError,
  
  updateEventCancel,
  updateEventCancelSuccess,
  updateEventCancelError,
}

export default actions
